import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { BlogArticleModel } from '@smarttask-common/src/lib/models/Prismic/Blog/BlogArticleModel';

export enum BlogActionTypes {
    ADD_BLOG = '[Blog] Create Blog',
    ADD_BLOGS = '[Blog] Add Blogs',
    UPSERT_BLOG = '[Blog] Upsert Blog',
    UPSERT_BLOGS = '[Blog] Upsert Blogs',
    UPDATE_BLOG = '[Blog] Update Blog',
    UPDATE_BLOGS = '[Blog] Update Blogs',
    DELETE_BLOG = '[Blog] Delete Blog',
    DELETE_BLOGS = '[Blog] Delete Blogs',
    DELETE_ALL_BLOGS = '[Blog] Delete All Blogs',
    DELETE_ALL = '[Blog] Delete All',

    UPDATE_SELECTED_ID = '[Blog] Update SelectedId',
}

export class UpdateSelectedBlogId implements Action {
    readonly type = BlogActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_blog_uid: string) {}
}

export class AddOne implements Action {
    readonly type = BlogActionTypes.ADD_BLOG;
    constructor(public blog: BlogArticleModel) {}
}

export class AddMany implements Action {
    readonly type = BlogActionTypes.ADD_BLOGS;
    constructor(public blogs: Array<BlogArticleModel>) {}
}

export class UpsertOne implements Action {
    readonly type = BlogActionTypes.UPSERT_BLOG;

    constructor(public blog: BlogArticleModel) {}
}

export class UpsertMany implements Action {
    readonly type = BlogActionTypes.UPSERT_BLOGS;
    constructor(public blogs: Array<BlogArticleModel>) {}
}

export class UpdateOne implements Action {
    readonly type = BlogActionTypes.UPDATE_BLOG;
    constructor(public blog: Update<BlogArticleModel>) {}
}

export class UpdateMany implements Action {
    readonly type = BlogActionTypes.UPDATE_BLOGS;
    constructor(public blogs: Array<Update<BlogArticleModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = BlogActionTypes.DELETE_BLOG;
    constructor(public uid: string) {}
}

export class DeleteMany implements Action {
    readonly type = BlogActionTypes.DELETE_BLOGS;
    constructor(public uids: Array<string>) {}
}

export class DeleteAll implements Action {
    readonly type = BlogActionTypes.DELETE_ALL_BLOGS;
    constructor(public uids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = BlogActionTypes.DELETE_ALL;
    constructor() {}
}

export type BlogActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedBlogId;
